import React, { useState, useEffect, useContext } from "react";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import moment from "moment";
import getAllVraShiftAPIS from "apis/panel/vraShifts/vraShifts.js";
import PoolPrepApis from "apis/panel/PoolPrepRoster/poolPrepRoster";
import Context from "context/context";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const EditPoolPrepRoster = ({ id, onClose }) => {
  const { dispatch } = useContext(Context);
  const [region, setRegion] = useState("");
  const [practice, setPractice] = useState("");
  const [projectionDate, setProjectionDate] = useState(null);
  const [initialGoLiveDate, setInitialGoLiveDate] = useState(null);
  const [status, setStatus] = useState("");
  const [modality1, setModality1] = useState("");
  const [modality1Volume, setModality1Volume] = useState('')
  const [modality2, setModality2] = useState("");
  const [modality2Volume, setModality2Volume] = useState("");
  const [modality3, setModality3] = useState("");
  const [modality3Volume, setModality3Volume] = useState("");
  const [fullGoLiveDate, setFullGoLiveDate] = useState("");
  const [weekendsVraSupport, setWeekendsVraSupport] = useState("");
  const [weekdaysVraSupport, setWeekdaysVraSupport] = useState(0);
  const [coverageStart, setCoverageStart] = useState(dayjs());
  const [coverageEnd, setCoverageEnd] = useState(dayjs());
  const [shiftPattern, setShiftPattern] = useState("");
  const [handledByVra, setHandledByVra] = useState("");
  const [handledByRp, setHandledByRp] = useState("");
  const [remarks, setRemarks] = useState("");
  const [isActive, setIsActive] = useState(null);
  const [vraEmployees, setVraEmployees] = useState([])
  const [practices, setPractices] = useState([])
  const [poolPrepRosterId, setPoolPrepRosterId] = useState("")
  const { getAllVraRosterAPI } = getAllVraShiftAPIS();
  const { getPoolPrepFindOne, updatePoolPrepAPI, getAllPracticesAPI } = PoolPrepApis();

  const handleGetAllVraEmployees = async () => {
    try {
      let res = await getAllVraRosterAPI();
      setVraEmployees(res?.data?.vraMaster || []);
    } catch (err) { }
  };

  const handleGetAllPractices = async () => {
    try {
      let res = await getAllPracticesAPI();
      setPractices(res?.data?.RpPractices || []);
    } catch (err) { }
  };

  useEffect(() => {
    handleGetAllVraEmployees();
    handleGetAllPractices()
  }, []);

  useEffect(() => {
    handleGetEditDataObj();
  }, []);

  const handleGetEditDataObj = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let values;
      values = {
        poolPrepRosterId: id,
      };

      const res = await getPoolPrepFindOne(values);

      if (res?.data) {

        setPoolPrepRosterId(id);
        setRegion(res?.data?.poolPrepRosterDetails?.region);
        setPractice(res?.data?.poolPrepRosterDetails?.practice);
        setProjectionDate(res?.data?.poolPrepRosterDetails?.projection_date);
        setInitialGoLiveDate(res?.data?.poolPrepRosterDetails?.initial_soft_go_live_date);
        setStatus(res?.data?.poolPrepRosterDetails?.status);
        setModality1(res?.data?.poolPrepRosterDetails?.modality1);
        setModality1Volume(
          res?.data?.poolPrepRosterDetails?.modality1_volume
        );
        setModality2(
          res?.data?.poolPrepRosterDetails?.modality2
        );
        setModality2Volume(
          res?.data?.poolPrepRosterDetails?.modality2_volume
        )
        setModality3(
          res?.data?.poolPrepRosterDetails?.modality3
        );
        setModality3Volume(
          res?.data?.poolPrepRosterDetails?.modality3_volume
        )
        setFullGoLiveDate(
          res?.data?.poolPrepRosterDetails?.full_go_live_date
        );
        setWeekendsVraSupport(res?.data?.poolPrepRosterDetails?.no_of_vra_support_weekends);
        setWeekdaysVraSupport(res?.data?.poolPrepRosterDetails?.no_of_vra_support_weekdays);
        // setCoverageStart(res?.data?.poolPrepRosterDetails?.coverage_duration_starts_time);
        // setCoverageEnd(res?.data?.poolPrepRosterDetails?.coverage_duration_ends_time);
        setShiftPattern(res?.data?.poolPrepRosterDetails?.shift_pattern);
        setHandledByVra(res?.data?.poolPrepRosterDetails.handled_by_vra_id);
        setHandledByRp(res?.data?.poolPrepRosterDetails.handled_by_rp);
        setRemarks(res?.data?.poolPrepRosterDetails.remarks);
        setIsActive(res?.data?.poolPrepRosterDetails.is_active);
        // if (res?.data?.poolPrepRosterDetails.coverage_duration_starts_time) {
        //   const date = dayjs(
        //     `2024-11-21T${res?.data?.poolPrepRosterDetails.coverage_duration_starts_time, "h:mm A"}`
        //   );
        //   setCoverageStart(date);
        // }

        if (res?.data?.poolPrepRosterDetails.coverage_duration_starts_time) {
          const timeString = res.data.poolPrepRosterDetails.coverage_duration_starts_time; // "08:00:00"
          const today = dayjs().format("YYYY-MM-DD");
          const dateTime = dayjs(`${today}T${timeString}`, "YYYY-MM-DDTHH:mm:ss");
          setCoverageStart(dateTime);
        }
        if (res?.data?.poolPrepRosterDetails.coverage_duration_ends_time) {
          const timeString = res.data.poolPrepRosterDetails.coverage_duration_ends_time; // "08:00:00"
          const today = dayjs().format("YYYY-MM-DD");
          const dateTime = dayjs(`${today}T${timeString}`, "YYYY-MM-DDTHH:mm:ss");
          setCoverageEnd(dateTime);
        }
      }
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const maxDate = new Date();

  const [errorFields, setErrorFields] = useState({
    region: false,
    practice: false,
    projectionDate: false,
    initialGoLiveDate: false,
    modality1: false,
    modality1Volume: false,
    modality2: false,
    modality2Volume: false,
    status: false,
    modality3: false,
    modality3Volume: false,
    fullGoLiveDate: false,
    coverageStart: false,
    coverageEnd: false,
    shiftPattern: false,
    handledByVra: false,
    handledByRp: false,
   
  });

  const handleSavePoolPrepEdit = async (e) => {
    e.preventDefault();

    const errors = {};

    if (!region) errors.region = true;
    if (!practice) errors.practice = true;
    if (!modality1Volume) errors.modality1Volume = true;
    if (!modality1) errors.modality1 = true;
    if (!modality2) errors.modality2 = true;
    if (!modality2Volume) errors.modality2Volume = true;
    if (!modality3) errors.modality3 = true;
    if (!modality3Volume) errors.modality3Volume = true;
    // if (!projectionDate) errors.projectionDate = true;
    if (!status) errors.status = true;
    if (!initialGoLiveDate) errors.initialGoLiveDate = true;
    if (!shiftPattern) errors.shiftPattern = true;
    if (!fullGoLiveDate) errors.fullGoLiveDate = true;
    if (!coverageStart) errors.coverageStart = true;
    if (!coverageEnd) errors.coverageEnd = true;
    if (!handledByVra) errors.handledByVra = true;
    if (!handledByRp) errors.handledByRp = true;
   
    setErrorFields(errors);

    if (Object.keys(errors).length === 0) {
      let values = {
        poolPrepRosterId: poolPrepRosterId,
        region: region,
        practice: practice,
        modality1Volume: parseFloat(modality1Volume),
        modality1: modality1,
        modality2: modality2,
        modality2Volume: parseFloat(modality2Volume),
        modality3: modality3,
        modality3Volume: parseFloat(modality3Volume),
        status: status,
        weekendsVraSupport: parseFloat(weekendsVraSupport),
        weekdaysVraSupport: parseFloat(weekdaysVraSupport),
        shiftPattern: shiftPattern,
        handledByVra: handledByVra,
        handledByRp: handledByRp,
        coverageStart: coverageStart.format("hh:mm A"),
        coverageEnd: coverageEnd.format("hh:mm A"),
        remarks: remarks,

      };
      if (moment(projectionDate).isValid()) {
        values = {
          ...values,
          projectionDate: moment(projectionDate).format("YYYY-MM-DD"),
        };
      }
      if (moment(initialGoLiveDate).isValid()) {
        values = {
          ...values,
          initialGoLiveDate: moment(initialGoLiveDate).format(
            "YYYY-MM-DD"
          ),
        };
      }
      if (moment(fullGoLiveDate).isValid()) {
        values = {
          ...values,
          fullGoLiveDate: moment(fullGoLiveDate).format("YYYY-MM-DD"),
        };
      }


      dispatch({ type: "SET_LOADING", payload: true });

      const res = await updatePoolPrepAPI(values);

      if (res.status === "Ok") {
        onClose();
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.success("Data Saved Successfully", {
          toast: "Data Saved Successfully",
        });
      } else {
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.error("Error: User already exists in the system");
      }
    }
  };

  

  const handleRegionChange = (event) => {
    const input = event.target.value;
    setRegion(input);
  };

  const handleModality1VolumeChange = (event) => {
    const input = event.target.value;
    setModality1Volume(input);
  };

  const handleModality1Change = (event) => {
    const input = event.target.value;
    setModality1(input);
  };

  const handleModality2VolumeChange = (event) => {
    const input = event.target.value;
    setModality2Volume(input);
  };

  const handleModality2Change = (event) => {
    const input = event.target.value;
    setModality2(input);
  };

  const handleModality3VolumeChange = (event) => {
    const input = event.target.value;
    setModality3Volume(input);
  };

  const handleModality3Change = (event) => {
    const input = event.target.value;
    setModality3(input);
  };

  const handleFullGoLiveDateChange = (date) => {


    setFullGoLiveDate(date);

  };

  const handleWeekendsVraSupportChange = (event) => {
    const input = event.target.value;

    setWeekendsVraSupport(input);

  };

  const handleWeekdaysVraSupportChange = (event) => {
    const input = event.target.value;

    setWeekdaysVraSupport(input);

  };

  const handleInitialGoLiveDateChange = (date) => {
    setInitialGoLiveDate(date);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleShiftPatternChange = (event) => {
    setShiftPattern(event.target.value);
  };

  const handleHandledByRpChange = (event) => {
    setHandledByRp(event.target.value);
  };

 
  const handleProjectionDateChange = (date) => {

    setProjectionDate(date);
  };


  return (
    <div style={{ backgroundColor: "white" }}>
      <Grid container spacing={2} sx={{ pl: 4, pr: 5 }}>

        {/* Region */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Region <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="region"
              id="region"
              defaultValue=""
              displayEmpty
              name="region"
              value={region}
              onChange={handleRegionChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem value="">Select Region</MenuItem>
              <MenuItem value={"Matrix"}>Matrix</MenuItem>
              <MenuItem value={"Special Operations"}>Special Operations</MenuItem>
              <MenuItem value={"Apex"}>Apex</MenuItem>
              <MenuItem value={"Genesis"}>Genesis</MenuItem>
              <MenuItem value={"Maverick"}>Maverick</MenuItem>
              <MenuItem value={"Trailblazer"}>Trailblazer</MenuItem>
              <MenuItem value={"Genesis / Special Operations"}>Genesis / Special Operations</MenuItem>
            </Select>
          </FormControl>
         {errorFields.region && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* Practice */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label"> 
            {" "}
            Practice<span style={{ color: "red" }}>*</span></Box>
          <Autocomplete
            id="practice"
            options={practices}
            getOptionLabel={(option) => option.practiceName || ""}
            renderInput={(params) => <TextField {...params} placeholder='Enter Practice' fullWidth />}
            isOptionEqualToValue={(option, value) =>
              option.practiceName === value.practiceName
            }
            value={
              practices?.filter((p) => p.practiceName === practice)[0] ||
              {}
            }
            onChange={(event, newValue) => {
              setPractice(newValue ? newValue.practiceName : "");
            }}
          />
          {errorFields.practice && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

         {/* projection date  */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Projection Date </Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="projectionDate"
              name="projectionDate"
              value={
                projectionDate ? new Date(projectionDate) : null
              }
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleProjectionDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: { clearable: true },
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
              minDate={new Date("2024-01-01")}
            />
          </LocalizationProvider>
          {/* {errorFields.projectionDate && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )} */}
        </Grid>
   
          {/* initial go live date    */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Initial/Soft Go Live Date<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="initialGoLiveDate"
              name="initialGoLiveDate"
              value={initialGoLiveDate ? new Date(initialGoLiveDate) : null}
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleInitialGoLiveDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: {
                  clearable: true,
                  onClear: () => setInitialGoLiveDate(null),
                },
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
              minDate={new Date("2024-01-01")}
            />
          </LocalizationProvider>
          {errorFields.initialGoLiveDate && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

         {/* status */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Status <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="status"
              id="status"
              defaultValue=""
              displayEmpty
              name="status"
              value={status}
              onChange={handleStatusChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem value="">Select Status</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              <MenuItem value={"Paused"}>Paused</MenuItem>
              <MenuItem value={"Discontinued"}>Discontinued</MenuItem>
              <MenuItem value={"Planned"}>Planned</MenuItem>
            </Select>
          </FormControl>
         {errorFields.status && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* Modality 1 */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 1 <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality1"
            value={modality1}
            name="modality1"
            onChange={handleModality1Change}
            placeholder="Enter Modality 1"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality1 && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* Modality1 Volume */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 1 Volume<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality1Volume"
            value={modality1Volume}
            name="modality1Volume"
            onChange={handleModality1VolumeChange}
            placeholder="Enter Modality 1 Volume"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality1Volume && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

          {/* full GoLive Date     */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
             {" "}
            Full Go Live Date<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="fullGoLiveDate"
              name="fullGoLiveDate"
              value={fullGoLiveDate ? new Date(fullGoLiveDate) : null}
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleFullGoLiveDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: { clearable: true },
              }}
              // minDate={new Date}
              // maxDate={maxDate}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>
          {errorFields.fullGoLiveDate && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* Modality 2 */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 2<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality2"
            value={modality2}
            name="modality2"
            onChange={handleModality2Change}
            placeholder="Enter Modality 2"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality2 && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* Modality 2 Volume */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 2 Volume<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality2Volume"
            value={modality2Volume}
            name="modality2Volume"
            onChange={handleModality2VolumeChange}
            placeholder="Enter Modality 2 Volume"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality2Volume && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* modality 3 */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 3<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality3"
            value={modality3}
            name="modality3"
            onChange={handleModality3Change}
            placeholder="Enter Modality 3"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality3 && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* modality 3 volume */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Modality 3 Volume<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="modality3Volume"
            value={modality3Volume}
            name="modality3Volume"
            onChange={handleModality3VolumeChange}
            placeholder="Enter Modality 3 Volume"
            variant="outlined"
            fullWidth
          />
          {errorFields.modality3Volume && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

          {/* vra support weekdays */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
             {" "}
            No of VRA Support Weekdays
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="weekdaysVraSupport"
            value={weekdaysVraSupport}
            onChange={handleWeekdaysVraSupportChange}
            placeholder="Enter No of VRA Support Weekdays"
            variant="outlined"
            fullWidth
            type="number" 
          />
         
        </Grid>

        {/* vra support weekends */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
             {" "}
            No of VRA Support Weekends 
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="weekendsVraSupport"
            value={weekendsVraSupport}
            onChange={handleWeekendsVraSupportChange}
            placeholder="Enter No of VRA Support Weekends"
            variant="outlined"
            fullWidth
            type="number" 
          />
          
        </Grid>

         {/* coverage start time */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Coverage Duration Start Time<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
              components={["TimePicker"]}
              style={{ overflowY: "scroll" }}
            >
              <TimePicker
                label=""
                value={coverageStart}
                sx={{ width: "100%" }}
                onChange={(newValue) => {
                  setCoverageStart(newValue);
                }}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorFields.coverageStart && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

         {/* coverage end time    */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Coverage Duration End Time<span style={{ color: "red" }}>*</span></Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
              components={["TimePicker"]}
              style={{ overflowY: "scroll" }}
            >
              <TimePicker
                label=""
                value={coverageEnd}
                sx={{ width: "100%" }}
                onChange={(newValue) => {
                  setCoverageEnd(newValue);
                }}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorFields.coverageEnd && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* shift pattern */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
             {" "}
            Shift Pattern <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="shiftPattern"
            value={shiftPattern}
            onChange={handleShiftPatternChange}
            placeholder="Enter Shift Pattern"
            variant="outlined"
            fullWidth
          />
          {errorFields.shiftPattern && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* handled by Vra */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Handled By VH <span style={{ color: "red" }}>*</span></Box>
          <Autocomplete
            id="handled-by-vra"
            options={vraEmployees}
            getOptionLabel={(option) => option.vraFullname || ""}
            renderInput={(params) => <TextField {...params} placeholder='Select handled by VH' fullWidth />}
            isOptionEqualToValue={(option, value) =>
              option.vraRosterId === value.vraRosterId
            }
            value={
              vraEmployees?.filter((v) => v.vraRosterId === handledByVra)[0] ||
              {}
            }
            onChange={(event, newValue) => {
              setHandledByVra(newValue ? newValue.vraRosterId : "");
            }}
          />
          {errorFields.handledByVra && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* handled by RP */}
        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Handled By RP<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="handledByRp"
            value={handledByRp}
            onChange={handleHandledByRpChange}
            placeholder="Enter handled by RP"
            variant="outlined"
            fullWidth
          />
          {errorFields.handledByRp && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        {/* Remarks */}
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            Remarks</Box>

          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="remarks"
            name="remarks"
            placeholder="Enter remarks"
            variant="outlined"
            fullWidth
            multiline
            rows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value.trimStart())}
            onBlur={(e) => setRemarks(e.target.value.trim())} />


        </Grid>

      </Grid>

      <Grid container sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }}>
        <Grid item xs={12} sm={2} md={2} lg={2}>
          <Button className="cancelButton" onClick={onClose}>
            Cancel
          </Button>
        </Grid>

        <Grid item sx={{ mr: 1 }} xs={12} sm={2} md={2} lg={2}>
          <Button className="saveButton" onClick={handleSavePoolPrepEdit}>
            Save
          </Button>
        </Grid>

      </Grid>
    </div>
  );
};

export default EditPoolPrepRoster;
